// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-monaco-editor {
  height: 100%;
  width: 100%;
  border-radius: 6px;
  transition: border-color 0.1s linear;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dl-monaco-editor .monaco-editor,
.dl-monaco-editor .monaco-editor-background,
.dl-monaco-editor .monaco-editor .inputarea.ime-input {
  background-color: var(--g-color-base-background);
}
.dl-monaco-editor .monaco-editor .margin {
  background-color: var(--g-color-base-background);
}
.dl-monaco-editor .monaco-editor .margin-view-overlays .line-numbers {
  cursor: inherit;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Monaco/Monaco.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;;;EAGI,gDAAA;AACR;AAEI;EACI,gDAAA;AAAR;AAKI;EACI,eAAA;AAHR","sourcesContent":[".dl-monaco-editor {\n  height: 100%;\n  width: 100%;\n  border-radius: 6px;\n  transition: border-color 0.1s linear;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dl-monaco-editor .monaco-editor,\n.dl-monaco-editor .monaco-editor-background,\n.dl-monaco-editor .monaco-editor .inputarea.ime-input {\n  background-color: var(--g-color-base-background);\n}\n.dl-monaco-editor .monaco-editor .margin {\n  background-color: var(--g-color-base-background);\n}\n.dl-monaco-editor .monaco-editor .margin-view-overlays .line-numbers {\n  cursor: inherit;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
